











import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import ThgCreateOverviewCard from "@/components/thg/ThgCreateOverviewCard.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { Component, Vue } from "vue-property-decorator";
import ThgClosingCard from "./ThgClosingCard.vue";

@Component({
  components: {
    LayoutReportStep,
    ThgCreateOverviewCard,
    ThgClosingCard
  }
})
export default class ThgClosing extends Vue {
  header: IReportHeaderData = {
    title: "report.thgClosing.title",
    description: "report.thgClosing.description"
  };

  isLoading = false;
}
